@use '@lib/assets/styles/main.scss' as *;

.havHeader {
  padding-top: 16px;
  padding-bottom: 0;
  @include responsive($md1) {
    padding-left: 32px;
    padding-right: 32px;
  }
  @include responsive(null, $md1) {
    padding-left: 16px;
    padding-right: 16px;
  }
}

.havHeaderGrid {
  display: grid;
  grid-template-columns: 40px auto 40px;
  align-items: center;
  grid-gap: 8px;
  text-align: center;
  min-height: 40px;
}
